<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card bg-white border-round">
    <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
      <div class="flex w-full items-center">
        <h2 class="m-0">Rebates Calculation Results</h2>
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Search"
          icon="pi pi-check"
          (click)="submitForm('search')"
          [loading]="isLoading"
        ></p-button>
        <p-button *ngIf="CanGenerateResult"
          label="Generate ({{ listCount }})"
          icon="pi pi-check"
          [loading]="isLoading"
          [disabled]="!hasNewStatus()"
          (click)="togglePopup(true)"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>
    <div class="card-body p-2">
      <form
        [formGroup]="filterForm"
        novalidate
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="off"
      >
        <div class="grid formgrid p-fluid">
          <!-- customer required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-users"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredCustomers"
                  formControlName="customer"
                  inputId="customer"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-customer pTemplate="selectedItem">
                    <div *ngIf="customer">
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template let-customer pTemplate="item">
                    <div>
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-customer>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #customerInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterCustomers($event)"
                        value="{{ CustomerfilterValue }}"
                      />
                      <!-- <p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="customer.reset(); customerInput.value = ''"
                        styleClass="p-button-secondary"
                      ></p-button> -->
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="customer">Customer</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['customer'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- business required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredBusinesses"
                  formControlName="business"
                  inputId="business"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-business pTemplate="selectedItem">
                    <div *ngIf="business">
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template let-business pTemplate="item">
                    <div>
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-business>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #businessInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterBusinesses($event)"
                        value="{{ BusinessfilterValue }}"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="business">Business</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['business'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- supplier required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredSuppliers"
                  formControlName="supplier"
                  inputId="supplier"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                >
                  <ng-template let-supplier pTemplate="selectedItem">
                    <div *ngIf="supplier">
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template let-supplier pTemplate="item">
                    <div>
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-supplier>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #supplierInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterSuppliers($event)"
                        [value]=""
                      />
                      <!-- <p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="supplier.reset(); supplierInput.value = ''"
                        styleClass="p-button-secondary"
                      ></p-button> -->
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="supplier">Supplier</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['supplier'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- process status required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="processStatus"
                  formControlName="arStatus"
                  optionLabel="label"
                  optionValue="value"
                  inputId="arStatus"
                  class="w-full"
                  placeholder="Select Process Status"
                  [required]="true"
                ></p-dropdown>
                <label for="arStatus">Process Status</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['arStatus'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDate"
                  [showIcon]="true"
                  inputId="startDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="startDate">Start Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['startDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="endDate"
                  [showIcon]="true"
                  inputId="endDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="endDate">End Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['endDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- contract type  required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="contractTypes"
                  formControlName="contractType"
                  optionLabel="label"
                  optionValue="label"
                  inputId="contractType"
                  class="w-full"
                  placeholder="Select Contract Type"
                  [required]="true"
                ></p-dropdown>
                <label for="contractType">Contract Type</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['contractType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- rebate trx start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="rebateTrxStartDate"
                  [showIcon]="true"
                  inputId="rebateTrxStartDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="rebateTrxStartDate"
                  >Rebate Transaction Start Date</label
                >
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['rebateTrxStartDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- rebate trx end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="rebateTrxEndDate"
                  [showIcon]="true"
                  inputId="rebateTrxEndDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [minDate]="filterForm.get('rebateTrxStartDate')?.value"
                ></p-datePicker>
                <label for="rebateTrxEndDate"
                  >Rebate Transaction End Date</label
                >
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['rebateTrxEndDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="rebateTrxNumber"
                  id="rebateTrxNumber"
                  class="w-full"
                  placeholder="Rebate Transaction Number"
                  [ngClass]="{ 'p-invalid': isInvalid('rebateTrxNumber') }"
                />
                <label for="rebateTrxNumber">Rebate Transaction#</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="refInvoice"
                  id="refInvoice"
                  class="w-full"
                  placeholder="Referance Invoice Number"
                  [ngClass]="{ 'p-invalid': isInvalid('refInvoice') }"
                />
                <label for="refInvoice">Referance Invoice#</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mt-2">
    <p-table
      #dt
      [value]="contractCalculations"
      [rows]="30"
      [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100, 500]"
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadContractCalculations($event)"
      [loading]="isLoading"
      [lazy]="true"
      dataKey="id"
      styleClass="p-datatable-striped overflow-x-auto"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="vendorNumber">
            Vendor# <p-sortIcon field="vendorNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="businessNumber">
            Business <p-sortIcon field="businessNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="source">
            Source <p-sortIcon field="source"></p-sortIcon>
          </th>
          <th pSortableColumn="type">
            Type <p-sortIcon field="type"></p-sortIcon>
          </th>
          <th pSortableColumn="period">
            Period <p-sortIcon field="period"></p-sortIcon>
          </th>
          <th pSortableColumn="contractNo">
            Contract# <p-sortIcon field="contractNo"></p-sortIcon>
          </th>
          <th pSortableColumn="customerNumber">
            Customer# <p-sortIcon field="customerNumber"></p-sortIcon>
          </th>
          <th>Address 1</th>
          <th>Address 2</th>
          <th pSortableColumn="area">
            Area <p-sortIcon field="area"></p-sortIcon>
          </th>
          <th pSortableColumn="city">
            City <p-sortIcon field="city"></p-sortIcon>
          </th>
          <th pSortableColumn="refInvoice">
            Ref Invoice <p-sortIcon field="refInvoice"></p-sortIcon>
          </th>
          <th pSortableColumn="refInvDate">
            Ref Inv Date <p-sortIcon field="refInvDate"></p-sortIcon>
          </th>
          <th pSortableColumn="itemCode">
            Item Code <p-sortIcon field="itemCode"></p-sortIcon>
          </th>
          <th pSortableColumn="vendorCatalog">
            Vendor Catalog <p-sortIcon field="vendorCatalog"></p-sortIcon>
          </th>
          <th pSortableColumn="unitStandardPrice">
            Unit Standard Price
            <p-sortIcon field="unitStandardPrice"></p-sortIcon>
          </th>
          <th pSortableColumn="unitePrice">
            Unit Price <p-sortIcon field="unitePrice"></p-sortIcon>
          </th>
          <th pSortableColumn="invQty">
            Inv Qty <p-sortIcon field="invQty"></p-sortIcon>
          </th>
          <th pSortableColumn="invAmount">
            Inv Amount <p-sortIcon field="invAmount"></p-sortIcon>
          </th>
          <th pSortableColumn="rebateTrxNumber">
            Rebate Trx# <p-sortIcon field="rebateTrxNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="rebateTrxDate">
            Rebate Trx Date <p-sortIcon field="rebateTrxDate"></p-sortIcon>
          </th>
          <th
            pSortableColumn="rebatePercent"
            style="width: 22rem; min-width: 22rem"
          >
            Rebate Percent <p-sortIcon field="rebatePercent"></p-sortIcon>
          </th>
          <th
            pSortableColumn="rebateAmount"
            style="width: 22rem; min-width: 22rem"
          >
            Rebate Amount <p-sortIcon field="rebateAmount"></p-sortIcon>
          </th>
          <th pSortableColumn="arStatus">
            AR Status <p-sortIcon field="arStatus"></p-sortIcon>
          </th>
          <th pSortableColumn="arBatchId">
            AR Batch ID <p-sortIcon field="arBatchId"></p-sortIcon>
          </th>
          <th pSortableColumn="arErrorMsg">
            AR Error Msg <p-sortIcon field="arErrorMsg"></p-sortIcon>
          </th>
          <th pSortableColumn="Ar Gl Segment">
            Ar Gl Segment <p-sortIcon field="Ar Gl Segment"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-contractCalculation>
        <tr>
          <td>{{ contractCalculation.vendorNumber }}</td>
          <td>
            {{ contractCalculation.businessNumber }} -
            {{ contractCalculation.businessName }}
          </td>
          <td>{{ contractCalculation.source }}</td>
          <td>{{ contractCalculation.type }}</td>
          <td>{{ contractCalculation.period }}</td>
          <td>{{ contractCalculation.contractNo }}</td>
          <td>
            {{ contractCalculation.customerNumber }} -
            {{ contractCalculation.customerName }} -
            {{ contractCalculation.billTo }}
          </td>
          <td>{{ contractCalculation.address1 }}</td>
          <td>{{ contractCalculation.address2 }}</td>
          <td>{{ contractCalculation.area }}</td>
          <td>{{ contractCalculation.city }}</td>
          <td>{{ contractCalculation.refInvoice }}</td>
          <td>{{ contractCalculation.refInvDate | date : "yyyy-MM-dd" }}</td>
          <td>
            {{ contractCalculation.itemCode }} -
            {{ contractCalculation.itemDesc }}
          </td>
          <td>{{ contractCalculation.vendorCatalog }}</td>
          <td>{{ contractCalculation.unitStandardPrice }}</td>
          <td>{{ contractCalculation.unitePrice }}</td>
          <td>{{ contractCalculation.invQty }}</td>
          <td>{{ contractCalculation.invAmount }}</td>
          <td>{{ contractCalculation.rebateTrxNumber }}</td>
          <td>{{ contractCalculation.rebateTrxDate | date : "yyyy-MM-dd" }}</td>
          <td class="rebate-col">
            {{ contractCalculation.rebatePercent }}
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.rebateUpdatedBy"
            >
              Old:
              {{ contractCalculation.originRebatePercent | number : "1.2-2" }} —
              updated by
              {{
                contractCalculation.rebateUpdatedBy?.fullName ||
                  contractCalculation.rebateUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.rebateUpdatedAt
                  | date : "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>
          <td class="rebate-col">
            <ng-container
              *ngIf="canEditRebate(contractCalculation); else viewRebateAmount"
            >
              <p-inputGroup class="rebate-input-group">
                <p-inputNumber
                  [mode]="'decimal'"
                  [maxFractionDigits]="2"
                  [showButtons]="true"
                  [ngModel]="
                    rebateAmountEdits[contractCalculation.lineId] ??
                    contractCalculation.rebateAmount
                  "
                  (ngModelChange)="
                    onRebateAmountChange(contractCalculation.lineId, $event)
                  "
                  [style]="{ width: '8rem' }"
                ></p-inputNumber>
                <p-inputGroupAddon>
                  <p-button
                    icon="pi pi-save"
                    label="Save"
                    [disabled]="savingRebate[contractCalculation.lineId]"
                    [loading]="savingRebate[contractCalculation.lineId]"
                    styleClass="p-button-success p-button-sm rebate-save-btn"
                    [style]="{ width: '8rem' }"
                    (click)="saveRebateAmount(contractCalculation)"
                  ></p-button>
                </p-inputGroupAddon>
              </p-inputGroup>
            </ng-container>
            <ng-template #viewRebateAmount>
              {{ contractCalculation.rebateAmount }}
            </ng-template>
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.rebateUpdatedBy"
            >
              Old:
              {{ contractCalculation.originRebateAmount | number : "1.2-2" }} —
              updated by
              {{
                contractCalculation.rebateUpdatedBy?.fullName ||
                  contractCalculation.rebateUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.rebateUpdatedAt
                  | date : "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>
          <td>{{ contractCalculation.arStatus }}</td>
          <td>{{ contractCalculation.arBatchId }}</td>
          <td>{{ contractCalculation.arErrorMsg }}</td>
          <td>{{ contractCalculation.arGlSegment1 
                + " - " + contractCalculation.arGlSegment2 
                + " - " + contractCalculation.arGlSegment3 
                + " - " + contractCalculation.arGlSegment4 
                + " - " + contractCalculation.arGlSegment5 
                + " - " + contractCalculation.arGlSegment6 
                + " - " + contractCalculation.arGlSegment7 
                + " - " + contractCalculation.arGlSegment8 
                + " - " + contractCalculation.arGlSegment9 
                + " - " + contractCalculation.arGlSegment10 
                }}</td> 
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Contracts found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-dialog
    header="Extra Info"
    [(visible)]="showPopup"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '30rem' }"
  >
    <form [formGroup]="extraForm">
      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-12">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-calendar"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <p-datePicker
                formControlName="trxDate"
                [showIcon]="true"
                inputId="trxDate"
                class="w-full"
                [appendTo]="'body'"
                [style]="{ width: '100%' }"
              ></p-datePicker>
              <label for="trxDate">Trx Date</label>
            </p-iftalabel>
            <p-inputgroup-addon>
              <p-button
                type="button"
                icon="pi pi-times"
                (click)="extraForm.controls['trxDate'].reset()"
                styleClass="p-button-secondary addOnBtnClear"
              ></p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
      </div>
      <div class="p-dialog-footer">
        <button pButton label="Confirm" (click)="submitForm('generate')"></button>
        <button pButton label="Cancel" class="p-button-text" (click)="showPopup = false"></button>
      </div>
    </form>
  </p-dialog>
</div>
